import AppLayout from 'layouts/AppLayout';
import AuthLayout from 'layouts/AuthLayout';
import MainLayout from 'layouts/MainLayout';
import Authentication from 'pages/Authentication';
import PageNotFound from 'pages/PageNotFound';
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { ROUTE_PATH } from './route.constant';
import ResetPasswordSuccess from 'pages/Authentication/ResetPasswordSuccess';
import NewStudentRegister from 'pages/NewStudentRegister';
import StudentRetaketation from 'pages/StudentRetaketation/index.jsx';
import CeuManagement from 'pages/CeuManagement';

const ChangePassword = React.lazy(
  () => import('../pages/Authentication/ChangePassword')
);
const MemberManagement = React.lazy(() => import('pages/MemberManagement'));
const AdminRegister = React.lazy(() => import('pages/AdminRegister'));
const NewsManagement = React.lazy(() => import('pages/NewsManagement'));
const CourseManagement = React.lazy(() => import('pages/CourseManagement'));
const CourseSchedule = React.lazy(() => import('pages/CourseSchedule'));
const FestivalManagement = React.lazy(() => import('pages/FestivalManagement'));
const FaqManagement = React.lazy(() => import('pages/FaqManagement'));
const StudioManagement = React.lazy(() => import('pages/StudioManagement'));
const SeminalManagement = React.lazy(() => import('pages/SeminalManagement'));
const EditorManagement = React.lazy(() => import('pages/Editor'));

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <AppLayout />,
      errorElement: <PageNotFound />,
      children: [
        {
          element: <AuthLayout />,
          children: [
            {
              path: ROUTE_PATH.LOGIN,
              element: <Authentication />,
            },
            {
              path: ROUTE_PATH.RESET_PASSWORD,
              element: <ChangePassword />,
            },
            {
              path: ROUTE_PATH.RESET_PASSWORD_SUCCESS,
              element: <ResetPasswordSuccess />,
            },
          ],
        },
        {
          element: <MainLayout />,
          children: [
            {
              path: ROUTE_PATH.MEMBER_MANAGEMENT,
              element: <MemberManagement />,
            },
            {
              path: ROUTE_PATH.ADMIN_REGISTER,
              element: <AdminRegister />,
            },
            {
              path: ROUTE_PATH.NEWS_MANAGEMENT,
              element: <NewsManagement />,
            },
            {
              path: ROUTE_PATH.COURSE_MANAGEMENT,
              element: <CourseManagement />,
            },
            {
              path: ROUTE_PATH.COURSE_SCHEDULE,
              element: <CourseSchedule />,
            },
            {
              path: ROUTE_PATH.FESTIVAL_MANAGEMENT,
              element: <FestivalManagement />,
            },
            {
              path: ROUTE_PATH.FAQ_MANAGEMENT,
              element: <FaqManagement />,
            },
            {
              path: ROUTE_PATH.STUDIO_MANAGEMENT,
              element: <StudioManagement />,
            },
            {
              path: ROUTE_PATH.SEMINAL_MANAGEMENT,
              element: <SeminalManagement />,
            },
            {
              path: ROUTE_PATH.NEW_STUDENT_REGISTER,
              element: <NewStudentRegister />,
            },
            {
              path: ROUTE_PATH.STUDENT_RETAKETATION,
              element: <StudentRetaketation />,
            },
            {
              path: ROUTE_PATH.CEU_MANAGEMENT,
              element: <CeuManagement />,
            },
            {
              path: ROUTE_PATH.EDITOR_MANAGEMENT,
              element: <EditorManagement />,
            },
          ],
        },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
    },
  }
);
